import React, { useState } from "react";
import { Main } from "components";
import { CSVLink } from "react-csv";
import { ReactComponent as ChartIcon } from "icons/chart.svg";
import { client } from "utils/api";
import ProductsPricesProvider, { useProductsPrices } from "./context/provider";
import Table from "./components/Table";
import Pagination from "./components/Pagination";
import CalculatorModal from "./components/CalculatorModal";
import ExchangeRatesModal from "./components/ExchangeRatesModal";

const AsideButtons = () => {
  const [is_exporting_offers, setIsExportingOffers] = useState(false);
  const [is_open_exchange_rates, setIsOpenExchangeRates] = useState(false);
  const {
    state: { csv_data, status },
    setOpenCalculator,
  } = useProductsPrices();
  if (status !== "success") {
    return null;
  }

  const exportOfferIds = async () => {
    try {
      setIsExportingOffers(true);
      const csvData = await client.post("/products/export_offer_ids", null, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(csvData);
      const link = document.createElement("a");
      link.href = url;
      link.download = `offers-ids-${new Date().toISOString().slice(0, 10)}.csv`;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
    } finally {
      setIsExportingOffers(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-blue nowrap m-r-0"
        onClick={() => setOpenCalculator(true)}
      >
        <span>Kalkulator</span>
      </button>
      <button
        type="button"
        className="btn btn-sm btn-blue nowrap"
        onClick={() => setIsOpenExchangeRates(true)}
      >
        <span>Kursy walut</span>
      </button>
      <ExchangeRatesModal
        is_open={is_open_exchange_rates}
        handleClose={() => setIsOpenExchangeRates(false)}
      />
      <CSVLink data={csv_data} separator=";" filename="ceny_produktow.csv">
        <button type="button" className="btn btn-sm btn-green">
          <span>Eksportuj do .csv</span>
        </button>
      </CSVLink>
      <button
        type="button"
        className="btn btn-sm btn-green"
        onClick={exportOfferIds}
        disabled={is_exporting_offers}
      >
        {is_exporting_offers ? (
          <span>Proszę czekać...</span>
        ) : (
          <span>Eksportuj id ofert do .csv</span>
        )}
      </button>
    </>
  );
};

const ProductsPrices = () => (
  <ProductsPricesProvider>
    <Main
      page={{
        name: "Analiza",
        icon: <ChartIcon />,
        breadcrumbs: [
          {
            name: "Analiza",
          },
        ],
        buttons: <AsideButtons />,
      }}
    >
      <CalculatorModal />
      <div className="main-list">
        <Table />
        <Pagination />
      </div>
    </Main>
  </ProductsPricesProvider>
);

export default ProductsPrices;
